// extracted by mini-css-extract-plugin
export default {"yearTableContainer":"MesecnaTabela_yearTableContainer__gJ7xd","spinner":"MesecnaTabela_spinner__ukW36"};